import { Button, Menu, MenuButton, MenuGroup, MenuItem, MenuList, Text } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';

import { onDownloadFile } from '@pages/AuditTrail/helpers/crud';
import { onClickDownloadFile } from '@pages/AuditTrail/helpers/events';
import { useDownloadNotification } from '@store/downloadNotification';
import { useMainState } from '@pages/AuditTrailSellOut/state/state';

export default function Export() {
    const { selectedAuditTrail: values } = useMainState();
    const { onChangeDownloadNotification } = useDownloadNotification();

    const downloadOptions = [
        {
            label: 'Download File',
            show: values?.meta_data?.is_download_original_file,
            onClick: () =>
                onClickDownloadFile({
                    values,
                    onChangeDownloadNotification,
                }),
        },
        {
            label: 'Download Processed',
            show: values?.meta_data?.is_download_processed_file,
            onClick: () =>
                onDownloadFile({
                    type: 'processed-file',
                    path: values?.processed_filename,
                    onChangeDownloadNotification,
                }),
        },
    ];

    return (
        <Menu matchWidth>
            {({ isOpen }) => (
                <>
                    <MenuButton
                        as={Button}
                        bg="sagitarius.500"
                        borderRadius="6px"
                        rightIcon={<ChevronDownIcon color="white" transform={`rotate(${isOpen ? 180 : 0}deg)`} />}
                    >
                        <Text color="white">Export Data</Text>
                    </MenuButton>

                    <MenuList minWidth={'unset'} p="0" borderColor="neutral.200" overflow="clip">
                        <MenuGroup>
                            {downloadOptions
                                .filter((item) => item.show)
                                .map((item) => (
                                    <MenuItem key={item.label} p="12px" onClick={item.onClick}>
                                        {item.label}
                                    </MenuItem>
                                ))}
                        </MenuGroup>
                    </MenuList>
                </>
            )}
        </Menu>
    );
}
